import { render, staticRenderFns } from "./WarehouseItemManageWidgets.vue?vue&type=template&id=9c8c2362"
import script from "./WarehouseItemManageWidgets.vue?vue&type=script&lang=js"
export * from "./WarehouseItemManageWidgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports